import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Scrollable from '@wetransfer/transfer/component/scrollable';

const LanguagePickerItems = ({
  isOpen,
  setIsOpen,
  languages,
  listRef,
  currentLanguage,
  changeLanguage,
  handleListKeyDown,
  handleButtonFocus,
}) => (
  <Scrollable
    className={`languagepicker ${isOpen ? 'languagepicker-open' : ''}`}
  >
    <ul
      ref={listRef}
      className="languagepicker__list"
      aria-labelledby="languagepicker_target-button"
      role="menu"
      tabIndex="-1"
      id="languagepicker_menu-id"
      onKeyDown={handleListKeyDown}
    >
      {languages.map((language) => (
        <li key={'language_changer_' + language.value} role="none">
          <button
            aria-label={language.label}
            className={classnames({
              'languagepicker__active-item':
                currentLanguage.value === language.value,
            })}
            onClick={() => {
              changeLanguage(language.value);
              setIsOpen(false);
            }}
            onFocus={handleButtonFocus}
            data-value={language.value}
            role="menuitem"
            type="button"
            tabIndex="-1"
          >
            {language.label}
          </button>
        </li>
      ))}
    </ul>
  </Scrollable>
);

const languageShape = PropTypes.shape({
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
});

export const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(languageShape).isRequired,
  listRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  currentLanguage: languageShape.isRequired,
  changeLanguage: PropTypes.func.isRequired,
  handleListKeyDown: PropTypes.func.isRequired,
  handleButtonFocus: PropTypes.func.isRequired,
};

LanguagePickerItems.propTypes = propTypes;

export default LanguagePickerItems;
